import { ExperimentClient } from './ExperimentClient';

export const experiment = new ExperimentClient();
